import { cn } from '@kidshome/ui';

/**
 * Horizontal progress bar (chore completion, family goal). Track + fill are semantic tokens; the
 * width transition is reduced-motion aware. Exposes `progressbar` semantics with an accessible label.
 */
export function ProgressBar({
  percent,
  label,
  tone = 'primary',
  className,
}: {
  percent: number;
  label: string;
  tone?: 'primary' | 'secondary';
  className?: string;
}): React.ReactElement {
  const pct = Math.max(0, Math.min(100, percent));
  return (
    <div
      className={cn('h-2.5 overflow-hidden rounded-pill bg-surface-muted', className)}
      role="progressbar"
      aria-valuenow={Math.round(pct)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label}
    >
      <div
        className={cn(
          'h-full rounded-pill transition-[width] duration-slow ease-out motion-reduce:transition-none',
          tone === 'secondary' ? 'bg-secondary' : 'bg-primary',
        )}
        style={{ inlineSize: `${pct}%` }}
      />
    </div>
  );
}
